// Central content + assets for Verraleaf
export const BRAND = {
  name: "Verraleaf",
  parent: "Dhananjay Eximporter",
  tagline: "Natural. Sustainable. Better Future.",
  slogan: "Choose Verraleaf, Choose a Greener Future",
  logo: "/verraleaf-mark.png",
  parentLogo: "https://customer-assets-lxgj4vgw.emergentagent.net/job_verraleaf-eco/artifacts/tp4via3k_dhananjay%20exim%20original.png",
  email: "Verraleafeco@gmail.com",
  phone: "+91 7391910075",
  phoneRaw: "917391910075",
  website: "www.dhananjayeximporters.com",
  address: "158, 301, Dhananjay Paradise, Sector 4, Moshi Pradhikaran, PCMC, Pune - 412105",
};

export const IMAGES = {
  heroField: "https://images.pexels.com/photos/11942833/pexels-photo-11942833.jpeg",
  showcase: "/bagasse-products.jpg",
  aboutWhite: "/about-white.jpg",
  plateRound: "/plate-round.jpg",
  plateSquare: "/p-square-plate.jpg",
  plate3cp: "/plate-3cp.jpg",
  tray4cp: "/tray-4cp.jpg",
  tray5cp: "/tray-5cp.jpg",
  bowlWhite: "/bowl-white.jpg",
  bowlSmall: "/bowl-small.jpg",
  bowlNatural: "/bowl-natural.jpg",
  bowlWhiteLifestyle: "/bowl-white-lifestyle.jpg",
  containerSquare: "/container-square.jpg",
  container2cp: "/container-2cp.jpg",
  clamshellSquare: "/clamshell-square.jpg",
  clamshellRect: "/clamshell-rect.jpg",
  clamshellLarge: "/clamshell-large.jpg",
  clamshellHinged: "/clamshell-hinged.jpg",
  lidCup: "/lid-cup.jpg",
  lidNatural: "/lid-natural.jpg",
  lidFlat: "/container-lid-flat.jpg",
  leaves: "https://images.unsplash.com/photo-1502082553048-f009c37129b9?auto=format&fit=crop&w=1200&q=80",
  restaurant: "https://images.pexels.com/photos/20182301/pexels-photo-20182301.jpeg",
  plasticWaste: "/plastic-food-waste.jpg",
  landfillAerial: "/landfill-aerial.jpg",
  landfillOps: "/landfill-ops.jpg",
};

export const CATEGORIES = ["All", "Plates", "Bowls", "Containers", "Clamshell Boxes", "Lids"];

export const PRODUCTS = [
  { id: "round-plates", name: "Round Plates", category: "Plates", image: IMAGES.plateRound,
    description: "Sturdy round bagasse plates for everyday food service, crafted for premium presentation.",
    sizes: ["6\"", "7\"", "9\"", "10\""], material: "100% Sugarcane Bagasse",
    features: ["Oil Resistant", "Microwave Safe", "Compostable"] },
  { id: "square-plates", name: "Square Plates", category: "Plates", image: IMAGES.plateSquare,
    description: "Modern bleached square plates with clean edges for stylish plating and catering.",
    sizes: ["6\"", "8\"", "10\""], material: "100% Sugarcane Bagasse",
    features: ["Food Grade", "Freezer Safe", "Plastic-Free"] },
  { id: "3cp-plates", name: "3-Compartment Plate (3CP)", category: "Plates", image: IMAGES.plate3cp,
    description: "Three-section plates keeping meals neatly separated for cafeterias and thalis.",
    sizes: ["9\"", "10\"", "11\""], material: "100% Sugarcane Bagasse",
    features: ["Leak Resistant", "Microwave Safe", "Compostable"] },
  { id: "4cp-trays", name: "Meal Tray — 4 Compartment (4CP)", category: "Plates", image: IMAGES.tray4cp,
    description: "Four-section meal trays for balanced multi-item meals in institutional dining.",
    sizes: ["10\"", "11\"", "12\""], material: "100% Sugarcane Bagasse",
    features: ["Leak Resistant", "Freezer Safe", "Oil Resistant"] },
  { id: "5cp-trays", name: "Meal Tray — 5 Compartment (5CP)", category: "Plates", image: IMAGES.tray5cp,
    description: "Five-section meal trays ideal for airlines, railways and canteen thali service.",
    sizes: ["10.5\"", "11\"", "12\""], material: "100% Sugarcane Bagasse",
    features: ["Strong & Durable", "Food Grade", "Heat Resistant"] },
  { id: "soup-bowls", name: "Soup Bowls", category: "Bowls", image: IMAGES.bowlWhite,
    description: "Deep bowls engineered to hold hot soups and curries without warping.",
    sizes: ["8oz", "12oz", "16oz"], material: "100% Sugarcane Bagasse",
    features: ["Water Resistant", "Microwave Safe", "Compostable"] },
  { id: "dessert-bowls", name: "Dessert Bowls", category: "Bowls", image: IMAGES.bowlSmall,
    description: "Elegant small bowls for desserts, salads and side servings.",
    sizes: ["5oz", "8oz"], material: "100% Sugarcane Bagasse",
    features: ["Oil Resistant", "Plastic-Free", "Freezer Safe"] },
  { id: "serving-bowls", name: "Serving Bowls", category: "Bowls", image: IMAGES.bowlWhiteLifestyle,
    description: "Larger natural-fibre bowls for poke, salads and buffet service.",
    sizes: ["24oz", "32oz", "37oz"], material: "100% Sugarcane Bagasse",
    features: ["Strong & Durable", "Food Grade", "Compostable"] },
  { id: "takeaway-containers", name: "Takeaway Containers", category: "Containers", image: IMAGES.containerSquare,
    description: "Secure square takeaway containers built for delivery and cloud kitchens.",
    sizes: ["500ml", "750ml", "1000ml"], material: "100% Sugarcane Bagasse",
    features: ["Leak Resistant", "Microwave Safe", "Stackable"] },
  { id: "food-containers", name: "Food Containers", category: "Containers", image: IMAGES.container2cp,
    description: "Multi-compartment food containers for retail packaging and supermarket shelves.",
    sizes: ["2-CP", "500ml", "1000ml"], material: "100% Sugarcane Bagasse",
    features: ["Food Grade", "Compostable", "Strong & Durable"] },
  { id: "hinged-containers", name: "Hinged Containers", category: "Containers", image: IMAGES.clamshellHinged,
    description: "Attached-lid hinged containers that seal in one motion for fast service.",
    sizes: ["15oz", "22oz", "32oz"], material: "100% Sugarcane Bagasse",
    features: ["Hinged Lid", "Leak Resistant", "Compostable"] },
  { id: "burger-boxes", name: "Burger Boxes", category: "Clamshell Boxes", image: IMAGES.clamshellSquare,
    description: "Hinged clamshell burger boxes that keep food warm and presentable.",
    sizes: ["Single", "Regular", "Jumbo"], material: "100% Sugarcane Bagasse",
    features: ["Hinged Lid", "Oil Resistant", "Compostable"] },
  { id: "meal-boxes", name: "Meal Boxes", category: "Clamshell Boxes", image: IMAGES.clamshellLarge,
    description: "Large clamshell meal boxes for hearty takeaway and catering portions.",
    sizes: ["32oz", "2-CP", "3-CP"], material: "100% Sugarcane Bagasse",
    features: ["Leak Resistant", "Freezer Safe", "Plastic-Free"] },
  { id: "lunch-boxes", name: "Lunch Boxes", category: "Clamshell Boxes", image: IMAGES.clamshellRect,
    description: "Rectangular clamshell lunch boxes for everyday meals on the go.",
    sizes: ["20oz", "750ml", "1000ml"], material: "100% Sugarcane Bagasse",
    features: ["Strong & Durable", "Microwave Safe", "Compostable"] },
  { id: "sipper-lids", name: "Sipper & Cup Lids", category: "Lids", image: IMAGES.lidCup,
    description: "Bleached bagasse sipper lids that seal hot and cold cups securely.",
    sizes: ["Fits 8-16oz cups"], material: "Bagasse Fibre",
    features: ["Secure Fit", "Compostable", "Leak Resistant"] },
  { id: "bowl-lids", name: "Bowl & Soup Cup Lids", category: "Lids", image: IMAGES.lidNatural,
    description: "Natural-fibre lids that snap onto bowls and soup cups for transport.",
    sizes: ["Fits 8-16oz"], material: "Bagasse Fibre",
    features: ["Secure Fit", "Compostable", "Stackable"] },
  { id: "container-lids", name: "Container Lids", category: "Lids", image: IMAGES.lidFlat,
    description: "Matching lids for the full takeaway container and cup range.",
    sizes: ["Universal"], material: "Bagasse Fibre",
    features: ["Leak Resistant", "Food Grade", "Compostable"] },
];

export const FEATURES = [
  { icon: "Sprout", title: "100% Sugarcane Bagasse" },
  { icon: "Recycle", title: "Biodegradable" },
  { icon: "Leaf", title: "Compostable" },
  { icon: "Ban", title: "Plastic-Free" },
  { icon: "Microwave", title: "Microwave Safe" },
  { icon: "Snowflake", title: "Freezer Safe" },
  { icon: "Droplets", title: "Oil & Water Resistant" },
  { icon: "ShieldCheck", title: "Food Grade" },
  { icon: "Dumbbell", title: "Strong & Durable" },
  { icon: "Factory", title: "Sustainable Manufacturing" },
  { icon: "Globe2", title: "Export Quality" },
  { icon: "Boxes", title: "Bulk Supply" },
];

export const INDUSTRIES = [
  "Restaurants", "Hotels", "Cloud Kitchens", "Caterers",
  "Airlines", "Railways", "Hospitals", "Cafeterias",
  "Food Delivery", "Supermarkets", "Retail Stores", "Packaging Distributors",
];

export const LIFECYCLE = [
  { step: "01", title: "Sugarcane", desc: "Renewable crop harvested across fertile fields." },
  { step: "02", title: "Bagasse", desc: "Fibrous pulp reclaimed after juice extraction." },
  { step: "03", title: "Manufacturing", desc: "Moulded under heat & pressure — no plastic." },
  { step: "04", title: "Tableware", desc: "Premium, food-grade, export-ready products." },
  { step: "05", title: "Compost", desc: "Breaks down naturally within weeks." },
  { step: "06", title: "Healthy Soil", desc: "Returns nutrients to the earth. Zero waste." },
];

export const EXPORT_POINTS = [
  "Worldwide Export", "Bulk Orders", "Container Shipments",
  "OEM & Private Label", "Reliable Logistics", "Documentation Support",
];

export const QUALITY = [
  { icon: "ClipboardCheck", title: "Food Safe Production", desc: "Manufactured to international food-contact standards." },
  { icon: "SearchCheck", title: "Strict Quality Control", desc: "Every batch inspected before dispatch." },
  { icon: "SprayCan", title: "Hygienic Manufacturing", desc: "Clean, controlled production environment." },
  { icon: "Anvil", title: "Durable Products", desc: "Rigid, crack-resistant and reliable." },
  { icon: "Leaf", title: "Sustainable Materials", desc: "Renewable bagasse fibre, zero plastic." },
];

export const TESTIMONIALS = [
  { name: "Marcus Reindl", company: "GreenTable Distribution, Germany", rating: 5, text: "Verraleaf's consistency across container shipments is exceptional. Their documentation support made importing effortless." },
  { name: "Aisha Rahman", company: "Crescent Foods, UAE", rating: 5, text: "Premium quality bagasse tableware at competitive pricing. Our restaurant clients love the durability." },
  { name: "David Okonkwo", company: "EcoPack Wholesale, Nigeria", rating: 5, text: "Reliable supply chain and true export quality. Private label service exceeded our expectations." },
  { name: "Sophie Laurent", company: "La Verte Retail, France", rating: 5, text: "Beautiful, sturdy and genuinely compostable. Exactly what our eco-conscious customers ask for." },
];

export const FAQS = [
  { q: "What is bagasse?", a: "Bagasse is the fibrous residue left after extracting juice from sugarcane. It's a renewable by-product moulded into strong, food-grade tableware — a natural alternative to plastic and foam." },
  { q: "Is bagasse microwave safe?", a: "Yes. Our bagasse tableware is microwave safe and also holds up in the freezer, making it suitable for hot and cold foods alike." },
  { q: "Is it compostable?", a: "Absolutely. Verraleaf products are 100% compostable and biodegradable, breaking down naturally into healthy soil within weeks under composting conditions." },
  { q: "What certifications are available?", a: "Our products are manufactured to food-grade and international export standards. We can provide relevant compliance and test documentation on request for your market." },
  { q: "Can you supply bulk export orders?", a: "Yes. We specialise in bulk orders and full container shipments worldwide, with reliable logistics and complete export documentation support." },
  { q: "Do you offer private labeling?", a: "Yes. We offer OEM and private label services so you can market Verraleaf-quality tableware under your own brand." },
];

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Sustainability", href: "#sustainability" },
  { label: "Export", href: "#export" },
  { label: "Contact", href: "#contact" },
];
